import { Heading, Text, useTheme } from '@aws-amplify/ui-react'
import React from 'react'

export const SignInHeader = () => {
  const { tokens } = useTheme()

  return (
    <>
      <Heading
        padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
        level={5}
        fontWeight={600}
      >
        Please sign in to New Project Media
      </Heading>

      <Text
        variation="secondary"
        as="p"
        padding={`${tokens.space.medium} 0 0 ${tokens.space.xl}`}
        color="#828282"
      >
        For support please contact{' '}
        <a href="mailto:help@newprojectmedia.com">help@newprojectmedia.com</a>
      </Text>
    </>
  )
}
